export enum QuestionnaireGetterEnum {
  CPTS = 'cpts',
  RESPONSES = 'responses',
  NETWORK = 'network',
  ALLOCATION = 'allocation'
}
